import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MobileNavbar.css';

const MobileNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 35) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
        <nav className={`mobile-navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="mobile-navbar-container">
                <button className="hamburger-button" onClick={toggleMenu}>
                <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
                </button>
            </div>
        </nav>

      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="mobile-menu-links">
          <Link to="/" onClick={toggleMenu}>HOME</Link>
          <Link to="/episodes" onClick={toggleMenu}>EPISODES</Link>
          <Link to="/about" onClick={toggleMenu}>ABOUT</Link>
          <Link to="/contact" onClick={toggleMenu}>CONTACT</Link>
        </div>
      </div>
    </>
  );
};

export default MobileNavbar; 